<ms-event-group
    *ngFor="let group of model.groups; trackBy: trackGroup"
    [group]="group"
    [grouping]="model.grouping"
    [sportId]="model.sport.id"
    [hideFavourites]="hideFavourites"
    [useColoredIcon]="useColoredIcon"
    (toggle)="groupToggled($event)">
    <ng-container *ngFor="let event of group.events; index as index; trackBy: trackEvent">
        <ms-compact-event
            [event]="event"
            [isOutrightMarket]="isOutrightMarket"
            [tracking]="trackingGameDetails('NonGridable', index)"
            [media]="model.media"
            [state]="model.collapsed.events[event.id]"
            [showAllBetsButton]="showAllBetsButton"
            [hideOptionPanelHeaderForPriceBoost]="hideOptionPanelHeaderForPriceBoost"
            [betDetails]="betDetails"
            (eventClick)="eventClicked(event)"
            (collapse)="eventCollapsed(event.id, $event)" />
    </ng-container>
</ms-event-group>
